import { sortBreakpoints } from '../helpers/sortBreakpoints';
/** Calculate breakpoint by width */
export function calculateBreakpoint(screenWidth, breakpoints) {
    var sortedBreakpoints = sortBreakpoints(breakpoints);
    for (var _i = 0, sortedBreakpoints_1 = sortedBreakpoints; _i < sortedBreakpoints_1.length; _i++) {
        var b = sortedBreakpoints_1[_i];
        if (screenWidth >= b.width) {
            return b.name;
        }
    }
    // screenWidth is below lowest breakpoint,
    // so it will still be set to equal lowest breakpoint instead of null
    return sortedBreakpoints[sortedBreakpoints.length - 1].name;
}
//# sourceMappingURL=calculateBreakpoint.js.map